// generated by scripts/emit_report_fonts.py, do not edit
// Source of truth: apps/backend/api/constants/report_fonts.py
// Regenerate with `make generate-types`; CI fails on drift.

export const REPORT_FONTS = {
  "defaults": {
    "body": null,
    "heading": "fraunces"
  },
  "faces": [
    {
      "style": "normal",
      "weight": 400
    },
    {
      "style": "italic",
      "weight": 400
    },
    {
      "style": "normal",
      "weight": 600
    },
    {
      "style": "normal",
      "weight": 700
    }
  ],
  "fonts": [
    {
      "classification": "serif",
      "family": "Fraunces",
      "files": [
        "fraunces-latin-400-normal.woff2",
        "fraunces-latin-400-italic.woff2",
        "fraunces-latin-600-normal.woff2",
        "fraunces-latin-700-normal.woff2"
      ],
      "key": "fraunces",
      "package": "fraunces",
      "stack": "\"Fraunces\", ui-serif, Georgia, \"Times New Roman\", serif"
    },
    {
      "classification": "sans",
      "family": "Inter",
      "files": [
        "inter-latin-400-normal.woff2",
        "inter-latin-400-italic.woff2",
        "inter-latin-600-normal.woff2",
        "inter-latin-700-normal.woff2"
      ],
      "key": "inter",
      "package": "inter",
      "stack": "\"Inter\", \"Helvetica Neue\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif"
    },
    {
      "classification": "sans",
      "family": "Plus Jakarta Sans",
      "files": [
        "plus-jakarta-sans-latin-400-normal.woff2",
        "plus-jakarta-sans-latin-400-italic.woff2",
        "plus-jakarta-sans-latin-600-normal.woff2",
        "plus-jakarta-sans-latin-700-normal.woff2"
      ],
      "key": "plus-jakarta-sans",
      "package": "plus-jakarta-sans",
      "stack": "\"Plus Jakarta Sans\", \"Helvetica Neue\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif"
    },
    {
      "classification": "serif",
      "family": "Source Serif 4",
      "files": [
        "source-serif-4-latin-400-normal.woff2",
        "source-serif-4-latin-400-italic.woff2",
        "source-serif-4-latin-600-normal.woff2",
        "source-serif-4-latin-700-normal.woff2"
      ],
      "key": "source-serif-4",
      "package": "source-serif-4",
      "stack": "\"Source Serif 4\", ui-serif, Georgia, \"Times New Roman\", serif"
    },
    {
      "classification": "serif",
      "family": "Lora",
      "files": [
        "lora-latin-400-normal.woff2",
        "lora-latin-400-italic.woff2",
        "lora-latin-600-normal.woff2",
        "lora-latin-700-normal.woff2"
      ],
      "key": "lora",
      "package": "lora",
      "stack": "\"Lora\", ui-serif, Georgia, \"Times New Roman\", serif"
    },
    {
      "classification": "sans",
      "family": "IBM Plex Sans",
      "files": [
        "ibm-plex-sans-latin-400-normal.woff2",
        "ibm-plex-sans-latin-400-italic.woff2",
        "ibm-plex-sans-latin-600-normal.woff2",
        "ibm-plex-sans-latin-700-normal.woff2"
      ],
      "key": "ibm-plex-sans",
      "package": "ibm-plex-sans",
      "stack": "\"IBM Plex Sans\", \"Helvetica Neue\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif"
    },
    {
      "classification": "sans",
      "family": "DM Sans",
      "files": [
        "dm-sans-latin-400-normal.woff2",
        "dm-sans-latin-400-italic.woff2",
        "dm-sans-latin-600-normal.woff2",
        "dm-sans-latin-700-normal.woff2"
      ],
      "key": "dm-sans",
      "package": "dm-sans",
      "stack": "\"DM Sans\", \"Helvetica Neue\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif"
    },
    {
      "classification": "serif",
      "family": "Merriweather",
      "files": [
        "merriweather-latin-400-normal.woff2",
        "merriweather-latin-400-italic.woff2",
        "merriweather-latin-600-normal.woff2",
        "merriweather-latin-700-normal.woff2"
      ],
      "key": "merriweather",
      "package": "merriweather",
      "stack": "\"Merriweather\", ui-serif, Georgia, \"Times New Roman\", serif"
    }
  ],
  "limits": {
    "logo_max_bytes": 262144,
    "logo_max_edge_px": 800
  }
} as const;
